import { keepPreviousData, useQuery } from "@tanstack/react-query";
import moment from "moment";
import ReactPaginate from "react-paginate";
import { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";

import Sidebar from "../sidebar";
import { getCustomerCartList } from "./customer-cart-list-section.service";

export default function CustomerCartListSection() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const pageParam = queryParams.get("page");
  const [currentPage, setCurrentPage] = useState(
    pageParam ? parseInt(pageParam) : 1
  );

  useEffect(() => {
    if (pageParam) {
      setCurrentPage(parseInt(pageParam));
    }
  }, [pageParam]);

  const {
    isPending,
    isError,
    data: response,
    error,
  } = useQuery({
    queryKey: ["admin-get-customer-cart-list", currentPage],
    queryFn: () => getCustomerCartList({ page: currentPage }),
    placeholderData: keepPreviousData,
  });

  const handlePageChange = (selectedItem: { selected: number }) => {
    const newPage = selectedItem.selected + 1;
    setCurrentPage(newPage);
    navigate(`?page=${newPage}`);
  };

  return (
    <section className="ec-page-content ec-vendor-dashboard section-space-p">
      <div className="container">
        <div className="row">
          <Sidebar />
          <div className="ec-shop-rightside col-lg-9 col-md-12">
            <div className="ec-vendor-dashboard-card space-bottom-30">
              <div className="ec-vendor-card-header">
                <h5>Customer Cart List</h5>
              </div>
              <div className="ec-vendor-card-body">
                <div className="ec-vendor-card-table">
                  <table className="table ec-table">
                    <thead>
                      <tr>
                        <th scope="col">Company Name</th>
                        <th scope="col">User</th>
                        <th scope="col">Cart Item Count</th>
                      </tr>
                    </thead>
                    <tbody>
                      {response?.data.results.map((order: any) => (
                        <tr key={order.id}>
                          <td className="fw-bold">{order.customer}</td>
                          <td>{order.name}</td>
                          <td>{order.totalQuantity}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="col-lg-12">
                  <ReactPaginate
                    nextLabel=">>"
                    onPageChange={handlePageChange}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={2}
                    pageCount={response?.data.totalPages}
                    forcePage={currentPage - 1}
                    previousLabel="<<"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                    renderOnZeroPageCount={null}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
